import {
    LOADING_LIQUIDACIONES,
    LOADING_ORDENES_LIQUIDACION,
    LOADING_NOVEDADES_LIQUIDACION,
    FETCH_ACCIONES_LIQUIDACIONES,
    FETCH_ESTADOS_LIQUIDACIONES,
    FETCH_RESULTADOS_LIQUIDACIONES,
    FETCH_LIQUIDACIONES_BUSQUEDA,
    FETCH_LIQUIDACION_POR_ID,
    FETCH_LIQUIDACION_POR_ID_ORDENES,
    FETCH_LIQUIDACION_POR_ID_LOGISTICA,
    FETCH_LIQUIDACION_POR_ID_NOVEDADES,
    FETCH_ORDENES_PARA_NUEVA_LIQUIDACION,
    FETCH_NOVEDADES_PARA_NUEVA_LIQUIDACION,
    LOADING_LOGISTICA_LIQUIDACION,
    LIMPIAR_LIQUIDACIONES_BUSQUEDA,
    SET_FILTRO_LIQUIDACIONES,
    RESET_FILTRO_LIQUIDACIONES,
    RESET_LIQUIDACIONES,
    UPDATE_LIST_LIQUIDACIONES,
    UPDATE_ESTADO_LIQUIDACION,
    UPDATE_IMPORTE_NOVEDAD_RESULTADOS,
    REMOVE_NOVEDAD_RESULTADOS,
    FETCH_DETALLE_RETENCIONES,
    RESET_PERCEPCION_RETENCION_LIQUIDACION,
    SET_PERCEPCION_RETENCION,
    UPDATE_LIST_TIPOS_PUBLICACIONES,
    UPDATE_CUERPO_ORDENES_LIQUIDACION,
    LOADING_DETALLE_LIQUIDACION,
    LOADING_DETALLE_RETENCIONES,
    // UPDATE_ESTADO_LIQUIDACION
} from '../actions/types';

const initialState = {
    isLoadingLiquidaciones: false,
    isLoadingOrdenesLiquidacion: false,
    isLoadingNovedadesLiquidacion: false,
    isLoadingLogisticaLiquidacion: false,
    lista_acciones_liquidaciones: [],
    lista_estados_liquidaciones: [],
    lista_resultados_liquidaciones: [],
    lista_liquidaciones_busqueda: [],
    cantidadTotalLiquidacionesBusqueda: 0,
    liquidacion_por_id: [],
    liquidacion_por_id_ordenes: [],
    liquidacion_por_id_logistica: [],
    liquidacion_por_id_novedades: [],
    ordenesLiquidacion: [],
    novedadesLiquidacion: [],
    cuerpoOrdenLiquidaciones: [],
    filtro: {},
    cuerpoFeeLogisticoLiquidaciones: [],
    cuerpoNovedadLiquidaciones: [],
    detalleRebate: [],
    detalleTributarioOrdenes: [],
    detalleTributarioLiquidacion: [],
    origenDetalleRetencion: '',
    percepcionRetencionLiquidacion: null,
    isLoadingDetalleLiquidacion: false,
    isLoadingDetalleRetenciones: false
}

const reducer = (state = initialState, action) => {

    switch (action.type) {

        case LOADING_LIQUIDACIONES:
            return {
                ...state,
                isLoadingLiquidaciones: action.payload
            };

        case LOADING_ORDENES_LIQUIDACION:
            return {
                ...state,
                isLoadingOrdenesLiquidacion: action.payload
            };

        case LOADING_NOVEDADES_LIQUIDACION:
            return {
                ...state,
                isLoadingNovedadesLiquidacion: action.payload
            };

        case LOADING_LOGISTICA_LIQUIDACION:
            return {
                ...state,
                isLoadingLogisticaLiquidacion: action.payload
            };

        case FETCH_ACCIONES_LIQUIDACIONES:
            return {
                ...state,
                lista_acciones_liquidaciones: action.payload
            };

        case FETCH_ESTADOS_LIQUIDACIONES:
            return {
                ...state,
                lista_estados_liquidaciones: action.payload
            };

        case FETCH_RESULTADOS_LIQUIDACIONES:
            return {
                ...state,
                lista_resultados_liquidaciones: action.payload
            };

        case FETCH_LIQUIDACIONES_BUSQUEDA: {
            const pl = action.payload;
            if (Array.isArray(pl)) {
                return {
                    ...state,
                    lista_liquidaciones_busqueda: pl,
                    cantidadTotalLiquidacionesBusqueda: pl.length
                };
            }
            return {
                ...state,
                lista_liquidaciones_busqueda: pl?.lista ?? [],
                cantidadTotalLiquidacionesBusqueda: pl?.cantidadTotal ?? 0
            };
        }

        case FETCH_LIQUIDACION_POR_ID:
            const encabezado = action.payload?.encabezadoLiquidacion ?? {};
            const cuerpoOrdenes = Array.isArray(action.payload?.cuerpoOrdenLiquidaciones)
                ? action.payload.cuerpoOrdenLiquidaciones
                : [];
            const cuerpoFee = Array.isArray(action.payload?.cuerpoFeeLogisticoLiquidaciones)
                ? action.payload.cuerpoFeeLogisticoLiquidaciones
                : [];
            const cuerpoNovedades = Array.isArray(action.payload?.cuerpoNovedadLiquidaciones)
                ? action.payload.cuerpoNovedadLiquidaciones
                : [];
            const detalleRebate = Array.isArray(action.payload?.detalleRebate)
                ? action.payload.detalleRebate
                : [];
            return {
                ...state,
                liquidacion_por_id: encabezado,
                cuerpoOrdenLiquidaciones: cuerpoOrdenes,
                cuerpoFeeLogisticoLiquidaciones: cuerpoFee,
                cuerpoNovedadLiquidaciones: cuerpoNovedades,
                detalleRebate,
            };


        case FETCH_LIQUIDACION_POR_ID_ORDENES:
            return {
                ...state,
                liquidacion_por_id_ordenes: Array.isArray(action.payload) ? action.payload : []
            };

        case FETCH_LIQUIDACION_POR_ID_NOVEDADES:
            return {
                ...state,
                liquidacion_por_id_novedades: Array.isArray(action.payload) ? action.payload : []
            };

        case FETCH_LIQUIDACION_POR_ID_LOGISTICA:
            return {
                ...state,
                liquidacion_por_id_logistica: Array.isArray(action.payload) ? action.payload : []
            };

        case FETCH_ORDENES_PARA_NUEVA_LIQUIDACION:
            return {
                ...state,
                ordenesLiquidacion: action.payload
            };

        case FETCH_NOVEDADES_PARA_NUEVA_LIQUIDACION:
            return {
                ...state,
                novedadesLiquidacion: action.payload
            };

        case LIMPIAR_LIQUIDACIONES_BUSQUEDA:
            return {
                ...state,
                lista_liquidaciones_busqueda: [],
                cantidadTotalLiquidacionesBusqueda: 0
            };
        case SET_FILTRO_LIQUIDACIONES:
            return {
                ...state,
                filtro: action.payload,
            };
        case RESET_FILTRO_LIQUIDACIONES:
            return {
                ...state,
                filtro: [],
                lista_liquidaciones_busqueda: [],
                cantidadTotalLiquidacionesBusqueda: 0,
                lista_resultados_liquidaciones: []

            };
        case RESET_LIQUIDACIONES:
            return {
                ...state,
                lista_liquidaciones_busqueda: [],
                cantidadTotalLiquidacionesBusqueda: 0
            };

        case UPDATE_LIST_LIQUIDACIONES:
            return {
                ...state,
                lista_liquidaciones_busqueda: action.payload,
            };
        case UPDATE_ESTADO_LIQUIDACION:
            return {
                ...state,
                liquidacion_por_id: action.payload
            };

        case UPDATE_IMPORTE_NOVEDAD_RESULTADOS: {
            const idNovedad = Number(action.payload?.idNovedad);
            const nuevoImporte = Number(action.payload?.importe);
            if (!Number.isFinite(idNovedad) || !Number.isFinite(nuevoImporte)) {
                return state;
            }

            return {
                ...state,
                lista_resultados_liquidaciones: Array.isArray(state.lista_resultados_liquidaciones)
                    ? state.lista_resultados_liquidaciones.map((item) => {
                        const itemId = Number(item?.idNovedad ?? item?.IdNovedad);
                        if (itemId !== idNovedad) return item;
                        return {
                            ...item,
                            importe: nuevoImporte,
                            importeNovedad: nuevoImporte,
                            Importe: nuevoImporte,
                            ImporteNovedad: nuevoImporte
                        };
                    })
                    : state.lista_resultados_liquidaciones
            };
        }

        case REMOVE_NOVEDAD_RESULTADOS: {
            const idNovedad = Number(action.payload?.idNovedad);
            if (!Number.isFinite(idNovedad)) {
                return state;
            }

            return {
                ...state,
                lista_resultados_liquidaciones: Array.isArray(state.lista_resultados_liquidaciones)
                    ? state.lista_resultados_liquidaciones.filter((item) => Number(item?.idNovedad ?? item?.IdNovedad) !== idNovedad)
                    : state.lista_resultados_liquidaciones
            };
        }

        case FETCH_DETALLE_RETENCIONES:
            return {
                ...state,
                detalleTributarioOrdenes: action.payload.detalleTributarioOrdenes,
                detalleTributarioLiquidacion: action.payload.detalleTributarioLiquidacion,
                origenDetalleRetencion: action.payload.origen,
                idLiquidacionDetalleTributario: action.payload.idLiquidacion 
            };

        case RESET_PERCEPCION_RETENCION_LIQUIDACION:
            return {
                ...state,
                cuerpoOrdenLiquidaciones: [],
                detalleTributarioOrdenes: [],
                detalleTributarioLiquidacion: [],
                origenDetalleRetencion: [],
                idLiquidacionDetalleTributario: [] 
            };

        case SET_PERCEPCION_RETENCION:
            return {
                ...state,
                percepcionRetencionLiquidacion: action.payload
            };

        case UPDATE_CUERPO_ORDENES_LIQUIDACION:
            return {
                ...state,
                cuerpoOrdenLiquidaciones: action.payload
            };

         case LOADING_DETALLE_LIQUIDACION:
            return {
                ...state,
                isLoadingDetalleLiquidacion: action.payload
            };

        case LOADING_DETALLE_RETENCIONES:
            return {
                ...state,
                isLoadingDetalleRetenciones: action.payload
            };

        default: return state
    }
}

export default reducer;
